<template>
	<Container :loading='loading'>
		<template v-for='modular in modulars'>
			<div class="carousel" v-if='modular.Code == "WSTraining001"'>
				<Carousel v-model="value1" loop autoplay :autoplay-speed='8000' dots='none'>
			        <CarouselItem v-for='item in modular.items'>
			            <a :href='configUrl(item)' class="carousel-item">
							<img class="img" :src="item.Pic">
						</a>
			        </CarouselItem>
			    </Carousel>
			    <div class="indicator">
			    	<div class="dots">
				    	<div class="dot" @mouseenter='value1=i - 1' :class='{active:i - 1==value1}' v-for='i in modular.items.length'></div>
				    </div>
			    </div>
			</div>
		</template>
		<div class="course">
			<div class="tabs">
				<div v-for='item in courses' class="tab" :class='{"active-tab":activeCourse.Code == item.Code}' @click='activeCourse = item'>{{item.Title}}</div>
			</div>
			<div class="content">
				<template v-if='activeCourse.Lessons&&activeCourse.Lessons.length'>
					<div class="section" v-for='section in activeCourse.Sections' :key='section.Code' v-if='section.Lessons && section.Lessons.length'>
						<div class="section-title" v-if='section.Title'>{{section.Title}}</div>
						<div class="items">
							<div class="item" v-for='lesson in section.Lessons' :key='lesson.Code'>
								<div class="cover zoom-out" @click='goPlay(lesson)'>
									<img v-lazysrc="lesson.Pic" :data-default='require("@/assets/defaultImg.png")' alt="" class="cover-img">
									<span class="tag">{{lesson.Flag | lessonStatus}}</span>
									<img src="@/assets/play.png" alt="" class="play">
								</div>
								<div class="bottom">
									<p class="name">{{lesson.Title}}</p>
									<div @click='goPlay(lesson)' class="button-primary detail">{{lesson.Flag | buttonTitle}}</div>
								</div>
							</div>
						</div>
						<!-- <div v-else class="coming-soon">
							敬请期待
						</div> -->
					</div>
				</template>
				<div v-else class="coming-soon">
					敬请期待
				</div>
			</div>
		</div>
		
	</Container>
</template>

<script>
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	export default {
		data() {
			return {
				value1:0,
				modulars:[],
				courses:[],
				activeCourse:{},
				loading:true,
			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{

		},
		mixins:[],
		filters: {
			lessonStatus(value){
				if (value <= 0) return '未观看'
				if (value <= 1) return '学习中'
				return '已看完'
			},
			buttonTitle(value){
				if (value <= 1) return '查看'
				if (value <= 10) return '未考核'
				if (value == 11) return '考核通过'
				if (value == 12) return '考核未通过'
			}
		},
		components: {
		},
		computed: {
			...mapState({

			}),
		},
		methods: {
			...mapActions([
				'getPageConfigAction',
				'getPageConfigDetailAction',
				'getELearnCourseAction',
			]),
			async initData(){
				this.loading = true
				let modulars = await this.getPageConfigAction('WSTraining')
				let response1 = await this.getPageConfigDetailAction({page:'WSTraining'})
				modulars.forEach(modular=>{
					let items = response1.filter(item=>item.Module == modular.Code)
					modular.items = items
				});
				let response = await this.getELearnCourseAction({
					QW:'',
					keys:'',
					startIndex:1,
					pageSize:30,
					isCount:10,
					status:-1,
				})
				if (response) {
					this.courses = response.Courses
					this.activeCourse = this.courses[0]
				}
				this.modulars = modulars;
				this.loading = false
			},
			goPlay(lesson){
				this.routerPush({
					path:'/train/detail',
					query:{
						lessonCode:lesson.Code
					},
					params:{
						lesson,
					}
				})
			}
		},
	}
</script>

<style lang='scss' scoped>
	@import '@/style/common';
	@import '@/style/mixin';
	.content {
		width: 79.17vw;
		margin: auto;
		.title {
			color:$theme-color;
			text-align: center;
			@include fontSize($font-size-20);
			font-weight: bold;
		}
		.section {
			.section-title {
				margin-top: 20px;
				@include fontSize($font-size-18);
				padding-bottom: 10px;
				border-bottom: 1px solid #ddd;
			}
		}
		.coming-soon {
			text-align: center;
			padding:80px;
		}
		.items {
			display: flex;
			padding-top: 30px;
			// justify-content: space-between;
			flex-wrap: wrap;
			.item {
				width:18vw;
				margin: 0 0.7vw;
				margin-bottom: 30px;
				border-radius: 10px;
				overflow: hidden;
				box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.2);
				.cover {
					height:11.25vw;
					display: flex;
					justify-content: center;
					align-items: center;
					position:relative;
					cursor: pointer;
					.cover-img {
						width:100%;
						height:100%;
						object-fit: cover;
					}
					.tag {
						position: absolute;
						right: 10px;
						top: 10px;
						background-color: $theme-color;
						color:white;
						padding: 3px 20px;
						border-radius: 20px;
					}
					.play {
						position:absolute;
						width:50px;
						height:50px;
					}
				}
				.bottom {
					display: flex;
					margin: 10px;
					justify-content: space-between;
					align-items: center;
					.name {
						white-space:nowrap;
						overflow:hidden;
						text-overflow: ellipsis;
					}
					.detail {
						padding:3px 10px;
						border-radius: 20px;
						min-width: 75px;
					}

				}
			}
		}
	}
	.tabs {
		display:flex;
		align-items: center;
		justify-content: space-around;
		border-bottom:1px solid #eee;
		margin-top: 40px;
		.tab {
			@include fontSize($font-size-24);
			padding: 10px 20px;
			cursor: pointer;
		}
		.active-tab {
			border-bottom:1px solid $theme-color;
			color:$theme-color;
		}
	}
	@media(max-width: 1000px){
		.content {
			width: 90vw;
			.items {
				.item {
					width:24vw;
					margin: 0 2vw;
					margin-bottom: 30px;
					.cover {
						height:15vw;
					}
				}
			}
		
		}	
	}
	@media (max-width: 768px){
		.content {
			width: 98vw;
			.items {
				.item {
					width:44vw;
					margin: 0 2vw;
					margin-bottom: 30px;
					.cover {
						height:27.5vw;
						.tag {
							right: 5px;
							top: 5px;
							padding: 3px 10px;
							border-radius: 20px;
						}
						.play {
							width:30px;
							height:30px;
						}
					}
				}
			}
		
		}
	}
</style>